import React, { useState } from 'react';
import { PageLoader, PaginationTable } from '@ver-uds/react';
import './DashboardUserAccountsTable.scss';
import { CompanyName } from 'eve-account-client';
import { Application } from '@vis-auth/vis-user-client';
import { EveRoutes } from '@ver-uds/e-verify';
import { Alert } from '@ver-uds/uswds-react';
import { userColumns } from '../../../../constants/Dashboard';
import { userAccountsRows } from '../../../../utils/dashboardUtils';
import { useDashboard } from '../../../../context/Dashboard/DashboardContext';
import useVisAuthService from '../../../../services/VisAuthService';

export type DashboardUserAccountsTableProps = {
  companyNames: CompanyName[];
};

const DashboardUserAccountsTable = ({ companyNames }: DashboardUserAccountsTableProps): JSX.Element => {
  const [isAuthenticating, setIsAuthenticating] = useState<boolean>(false);
  const [hasAuthError, setHasAuthError] = useState<boolean>(false);

  const { users } = useDashboard();

  const visAuth = useVisAuthService();
  const onUserButtonClick = async (userId: string): Promise<void> => {
    setHasAuthError(false);

    try {
      // hand off auth to VisAuthService
      setIsAuthenticating(true);
      await visAuth.handleAuthentication();
      await visAuth.claimUserSession(userId, Application.EVERIFY);

      // force redirect flow
      window.location.assign(EveRoutes.HOME);
    } catch (_) {
      setHasAuthError(true);
    } finally {
      setIsAuthenticating(false);
    }
  };

  return (
    <>
      {hasAuthError && (
        <Alert status="error" slim>
          <Alert.Text>
            We are unable to access your user account at this time. Please wait a few minutes and try again.
          </Alert.Text>
        </Alert>
      )}
      <div className="user-accounts-table-container">
        <PaginationTable
          id="user-accounts-table"
          sortable
          variant="default"
          columns={userColumns}
          data={userAccountsRows(users, companyNames, onUserButtonClick)}
        />
      </div>
      {isAuthenticating && <PageLoader label="Authenticating..." />}
    </>
  );
};

export default DashboardUserAccountsTable;
